import CryptoJS from "crypto-js";
import {api} from "./base.api.ts";

// Post
export const updateProfileInformation = async (teacherInformation) => {
    const res = await api.post("teacher-signup", teacherInformation);
    return res.data;
};

export const addTeacherAvailability = async (classAvailability) => {
    await api.post("addTeacherAvailability", classAvailability);
};

export const addPaymentMethod = async ({
                                           first_name,
                                           last_name,
                                           routing_number,
                                           account_number,
                                           email,
                                       }) => {
    const encryptData = {
        first_name: CryptoJS.AES.encrypt(first_name, email).toString(),
        last_name: CryptoJS.AES.encrypt(last_name, email).toString(),
        routing_number: CryptoJS.AES.encrypt(routing_number, email).toString(),
        account_number: CryptoJS.AES.encrypt(account_number, email).toString(),
    };
    await api.post("add-payment-method", encryptData);
};

export enum EnlistStatus {
    LIST = "list",
    UNLIST = "unlist",
}

export const changeTeacherListUnList = async (enlistStatus: EnlistStatus) => {
    await api.post("teacher-list-unlist", {enlist_status: enlistStatus});
};

// Get
export const getListBestRatingTeachers = async (limit) => {
    const res = await api.get("list-best-rating-teachers", {
        params: {
            limit,
        },
    });
    return res.data;
};

export const getListTeachersByBadge = async ({limit, badge}) => {
    const res = await api.get("list-teachers-by-badge", {
        params: {
            limit,
            badge
        },
    });
    return res.data;
};

export const getListUniqueClassTeachers = async (limit) => {
    const res = await api.get("list-unique-class-teachers", {
        params: {
            limit,
        },
    });
    return res.data;
};

export const getSimilarTeachers = async (params) => {
    const res = await api.get("get-similar-teachers", {
        params,
    });
    return res.data;
};

export const getTeacherDetailsById = async ({id}) => {
    const res = await api.get(`dashboard/getTeacherDetails/${id}`);
    return res.data;
};

export const getTeacherSlotByDayOnly = async ({teacher_id, day, date, online_type}) => {
    const res = await api.get(
        `dashboard/getTeacherSlotByDayOnly/${teacher_id}/${day}`,
        {params: {date, online_type}}
    );
    return res.data;
};

export const getAvailableDaysByMonth = async ({
                                                  teacher_id,
                                                  date,
                                                  month,
                                                  type,
                                                  number_of_participants,
                                                  online_type
                                              }) => {
    const res = await api.get(
        `getTeacherAvailableDaysByMonth`,
        {
            params: {
                teacher_id,
                date,
                online_type,
                type,
                month,
                number_of_participants
            }
        }
    );
    return res.data.data;
};

export const getListTeachers = async (params) => {
    const res = await api.get("list-teachers", {
        params,
    });
    return res.data;
};

